import React from "react";
import NavStep from "./NavStep";
import { useSteps } from "../steps/useSteps";

export default function Navigation() {
	const { step, stepsCount } = useSteps();
	const steps = [];

	for (let i = 0; i < stepsCount; i++) {
		steps.push(<NavStep key={i} currentStep={step} index={i} />);
	}

	return (
		<ol className="step-nav" role="navigation">
			{steps}
		</ol>
	);
}
